module.exports = __webpack_public_path__ + "static/media/20000d_p.7ec5bbc2.jpg";